<template>
  <Login></Login>
</template>

<script>

import Login from './Login'
export default {
	name: 'Home',
	components: { Login },
	computed: {
	}
}
</script>
